import {
	toQueryString,
	convertDataQueryLinksToHtmlAnchors,
	getImpliedLink,
	getImpliedLinks,
	getPostSignupUrl,
	resolveDocumentLink,
	resolveEmailLink,
	resolvePhoneLink,
	resolveAddressLink,
	resolveDynamicPageLink,
	resolveWhatsAppLink,
	getBaseUrlFilesPath,
	hasLinkDataWithCurrentRouteAnchors,
} from '@wix/link-utils'
import { getCustomizedUrlSegments } from '@wix/url-mapper-utils'
import type { UrlMappings } from '@wix/url-mapper-utils'

import { overrideSuffix, queryParamsWhitelist as defaultQueryParamsWhitelist } from './constants/queryParamsWhitelist'

const linkTypes = {
	DocumentLink: 'DocumentLink',
	EmailLink: 'EmailLink',
	ExternalLink: 'ExternalLink',
	PageLink: 'PageLink',
	DynamicPageLink: 'DynamicPageLink',
	TpaPageLink: 'TpaPageLink',
	PhoneLink: 'PhoneLink',
	WhatsAppLink: 'WhatsAppLink',
	AddressLink: 'AddressLink',
	LoginToWixLink: 'LoginToWixLink',
	AnchorLink: 'AnchorLink',
}

export const isLinkData = (linkData?: any) => {
	return linkTypes[linkData?.type as keyof typeof linkTypes]
}

const keepInternalQueryParamsOnly = (
	searchParams: URLSearchParams,
	queryParamsWhitelist: Set<string> = defaultQueryParamsWhitelist
) => {
	const entries = searchParams.entries()
	const filteredEntries = [...entries].filter(([key]) => queryParamsWhitelist.has(key) || key.endsWith(overrideSuffix))

	return new URLSearchParams(filteredEntries).toString()
}

export const appendInternalQueryParamsToHref = (href: string, currentUrl: URL) => {
	const nextUrl = new URL(href, currentUrl.origin)
	const nextUrlSearch = nextUrl.search
	nextUrl.search = keepInternalQueryParamsOnly(currentUrl.searchParams)

	new URLSearchParams(nextUrlSearch).forEach((val, key) => {
		nextUrl.searchParams.set(key, val)
	})

	return nextUrl.toString()
}

const getFullURL = (url: string, baseUrl: string): string => {
	return url.startsWith('http') ? url : `${baseUrl}${url.startsWith('/') ? url : `/${url}`}`
}

export const isUrlCustomized = (url: string, baseUrl: string, urlMappings: UrlMappings | undefined): boolean => {
	if (!urlMappings) {
		return false
	}

	try {
		const fullUrl = getFullURL(url, baseUrl)
		const { key } = getCustomizedUrlSegments(urlMappings, fullUrl, { baseUrl }) || {}
		return Boolean(key)
	} catch {
		return false
	}
}

export {
	toQueryString,
	convertDataQueryLinksToHtmlAnchors,
	getImpliedLink,
	getImpliedLinks,
	getPostSignupUrl,
	resolveDocumentLink,
	resolveEmailLink,
	resolvePhoneLink,
	resolveAddressLink,
	resolveDynamicPageLink,
	resolveWhatsAppLink,
	getBaseUrlFilesPath,
	hasLinkDataWithCurrentRouteAnchors,
}
